import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import de from './locales/de.json';
import en from './locales/en.json';
import pl from './locales/pl.json';
import ru from './locales/ru.json';
import sv from './locales/sv.json';

export const SUPPORTED_LANGUAGES = ['en', 'ru', 'de', 'pl', 'sv'] as const;

export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      ru: { translation: ru },
      de: { translation: de },
      pl: { translation: pl },
      sv: { translation: sv },
    },
    fallbackLng: 'en',
    supportedLngs: [...SUPPORTED_LANGUAGES],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage'],
      caches: ['localStorage'],
    },
  });

const syncDocumentLang = (lng: string) => {
  document.documentElement.lang = lng;
};

i18n.on('languageChanged', syncDocumentLang);
syncDocumentLang(i18n.resolvedLanguage ?? i18n.language);

export default i18n;
